import { animate, kpiAnimationDuration, parseHighlightValueDependingOnDecimals } from './utils/animation'

function init () {
  initializeKPIs()
}

function initializeKPIs () {
  const kpis = document.querySelectorAll('.kpi-cards')

  kpis.forEach((kpi) => {
    animateKpi(kpi)
  })
}

const animateKpi = (kpi) => {
  if (!kpi) return

  if (window.innerWidth >= 768) {
    kpi.style.flex = `1 0 calc(${kpi.dataset.minWidth} - 10px)`
  }
  const callback = animationCallback(kpi)

  const observer = new IntersectionObserver(callback, { threshold: [0, 0.75] })
  observer.observe(kpi)
}

const animationCallback = (kpi) => {
  const highlight = kpi.querySelector('.kpi-highlight-value')
  if (!highlight) return () => {
  }

  let { highlightValue, decimals } = parseHighlightValueDependingOnDecimals(highlight)
  const locale = kpi.dataset.lang

  return (entries) => {
    animateBasedOnIntersectionRatio(entries, highlight, kpiAnimationDuration, highlightValue, decimals, locale)
  }
}

function animateBasedOnIntersectionRatio (entries, highlight, animationDuration, highlightValue, decimals, locale) {
  if (!entries || !entries[0]) return

  const entry = entries[0]
  if (entry.isIntersecting && entry.intersectionRatio >= 0.75 && highlight.innerText == 0) {
    animate(highlight, animationDuration, highlightValue, decimals, locale)
  } else if (entry.intersectionRatio == 0) {
    highlight.innerText = 0
  }
}

export default {
  init,
}
